import React, {useEffect, useRef, useState} from 'react';
import {TableHead, TableRow, Table, TableBody, TableCell, TableContainer} from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import CreateUserModal from './CreateUserModal';
import useAxiosProtect from '../../../../hooks/useAxiosProtect';
import ReportModal from './ReportModal';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import { Modal, Button } from 'react-bootstrap';
import useAuth from '../../../../hooks/useAuth';
import jwtDecode from 'jwt-decode';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

const SettingsContainer = props => {
    const [reportModalOpen, setReportModalOpen] = useState(false);

    const {auth, persist} = useAuth();

    var init = useRef(true);
    const axiosProtect = useAxiosProtect();

    const [siteName, setSiteName] = useState('');
    const siteID = window.location.href.split('/')[window.location.href.split('/').length - 1];
    
    useEffect(() => {
        if(!init.current) return;
        init.current = false;

        if(auth?.accessToken){
            let tokenObj = jwtDecode(auth.accessToken);

        }
        if (props.independent === true) {

        }else {
            
            axiosProtect.get(`/s/sites/get-site-fields?fields=%5B%22id,name,org_id%22%5D&siteID=${siteID}`).then(response => {
                setSiteName(response.data.siteData.name);
            });
        }
    }, []);

    return (
        <>
        {reportModalOpen && <ReportModal  reportModalOpen={reportModalOpen} setReportModalOpen={setReportModalOpen} siteName={siteName} />}
        <IconButton style={{flex:'1', borderRadius:'2%', backgroundColor:'rgba(8,114,182, 0.1)'}} color="info">
            <p style={{margin:'1% 0', fontSize:'1.25rem'}} onClick={() => {
                setReportModalOpen(true);
            }}>Generate site report</p>
        </IconButton>
        </>
    );
};

export default SettingsContainer;
